import type { Conversation } from 'entities/Conversation'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { hasOpenFilter } from 'features/DropdownFilter/lib/hasOpenFilter'

export const hasNeedResponseFilter = (conversation: Conversation, entities: IEntitiesStore) => {
  return Boolean(conversation.is_need_response) && hasOpenFilter(conversation, entities)
}
